import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=6924f19c&scoped=true"
import script from "./SignDocument.vue?vue&type=script&lang=js"
export * from "./SignDocument.vue?vue&type=script&lang=js"
import style0 from "./SignDocument.vue?vue&type=style&index=0&id=6924f19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924f19c",
  null
  
)

export default component.exports